<script setup>
import MapNewsListCard from "@/components/MapPage/MapNews/MapNewsListCard.vue";
import { t } from "@/controllerLK/GlobusLocalization";
import { defineProps, defineEmits } from "vue";
import CrossIcon from "@/components/Icons/CrossIcon.vue";

const props = defineProps({
  isNewsListOpened: {
    type: Boolean,
    default: false,
    required: true
  },
  newsList: {
    type: Array,
    required: true,
    default: () => []
  },
  cityName: {
    type: String || null,
    default: null,
    required: false,
  }
});

const emit = defineEmits(["close-news-list"]);
</script>

<template>
  <div
    v-if="isNewsListOpened"
    class="news-wrapper"
  >
    <div class="news-wrapper-header">
      <div class="news-wrapper-header__title">
        {{ props.newsList.length > 0 ? cityName : '' }}, {{ props.newsList.length }} {{ t('map_news_list.title') }}
      </div>
      <div
        class="news-wrapper-header__button"
        @click="emit('close-news-list')"
      >
        <CrossIcon />
      </div>
    </div>

    <div class="news-wrapper-body scroll-map-news-list">
      <MapNewsListCard
        v-for="item in props.newsList"
        :key="item.id"
        :item="item"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.scroll-map-news-list {
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 23px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #CACACA;
    border: 8px solid transparent;
    background-clip: padding-box;
    border-radius: 30px;
  }
}

.news-wrapper {
  position: absolute;
  bottom: 14px;
  right: 0;
  display: flex;
  flex-direction: column;
  width: 537px;
  max-height: calc(100% - 82px);
  padding: 20px;
  border-radius: 10px;
  background: #EEF1F4;
  box-shadow: 0 0 16px 0 #24252824;
  gap: 10px;

  &-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    &__title {
      font-weight: 500;
      color: #212327;
    }

    &__button {
      color: #7B87A5;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #1F9AFF;
      }
    }
  }
}

</style>